/**
 * Manages access token and refresh token persistence across page reloads.
 * Synchronizes with memory and localStorage for instant hydration on F5 refresh.
 */
const ACCESS_TOKEN_KEY = 'mms_access_token';
const REFRESH_TOKEN_KEY = 'mms_refresh_token';

let inMemoryAccessToken: string | null = null;

export function getAccessToken(): string | null {
  if (inMemoryAccessToken) return inMemoryAccessToken;
  if (typeof window !== 'undefined') {
    try {
      const stored = localStorage.getItem(ACCESS_TOKEN_KEY);
      if (stored) {
        inMemoryAccessToken = stored;
        return stored;
      }
    } catch {
      // In case localStorage is blocked or unavailable
    }
  }
  return null;
}

export function setAccessToken(token: string | null): void {
  inMemoryAccessToken = token;
  if (typeof window !== 'undefined') {
    try {
      if (token) {
        localStorage.setItem(ACCESS_TOKEN_KEY, token);
      } else {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
      }
    } catch {
      // In case localStorage is blocked or unavailable
    }
  }
}

export function getStoredRefreshToken(): string | null {
  if (typeof window !== 'undefined') {
    try {
      return localStorage.getItem(REFRESH_TOKEN_KEY);
    } catch {
      return null;
    }
  }
  return null;
}

export function setStoredRefreshToken(token: string | null): void {
  if (typeof window !== 'undefined') {
    try {
      if (token) {
        localStorage.setItem(REFRESH_TOKEN_KEY, token);
      } else {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
      }
    } catch {
      // In case localStorage is blocked or unavailable
    }
  }
}
